import React, { useContext, useEffect, useState } from 'react'
import { observer } from 'mobx-react'
import ContentHeader from '@Components/ContentHeader'
import SongwriterCatalogBuilderHeader from '@Scenes/SongwriterScene/SongwriterCatalogBuilderScene/SongwriterCatalogBuilderHeader'
import { StoresContext } from '@App/contexts'
import SongwriterCatalogBuilderResults from '@Scenes/SongwriterScene/SongwriterCatalogBuilderScene/SongwriterCatalogBuilderResults'
import './index.scss'
import SongwriterCatalogBuilderTable from '@Scenes/SongwriterScene/SongwriterCatalogBuilderScene/SongwriterCatalogBuilderResults/SongwriterCatalogBuilderTable'
import SearchByParty from '@Components/Search/SearchByParty'
import ModalPortal from '@Components/Popups/ModalPortal'
import SongwriterHubWelcomePopup from '@Components/Popups/SongwriterHubWelcomePopup'
import SearchResultPartyDetailsCard from '@Components/Search/SearchByParty/SearchResultPartyDetailsCard'

const SongwriterCatalogBuilderScene = () => {
    const { songwriterWriterSearchStore, songwriterStore, userStore } = useContext(StoresContext)
    const userSettings = userStore.userInfo?.settings
    const [showFirstTimeSongwriterHubPopup, setShowFirstTimeSongwriterHubPopup] = useState<boolean>(
        !!(userSettings && userSettings.showSongwriterHubPopup)
    )

    useEffect(
        () => () => {
            songwriterWriterSearchStore.resetStore()
        },
        []
    )

    const firstTimeVisit = () => {
        // If it's a user's first time in the songwriter hub we automatically plug in their songwriter name
        // and search the catalog builder for them
        songwriterWriterSearchStore.setWriterNameForSearch(songwriterStore.songwriterSummary.name)
        songwriterWriterSearchStore.search().then()
    }

    const onWriterToggle = React.useCallback(
        async (isLinked: boolean, writerIpId: number) => {
            await songwriterWriterSearchStore.toggleSongwriterLink(isLinked, writerIpId)
        },
        [songwriterWriterSearchStore]
    )

    const linkedWriterIpIdSet = React.useMemo(
        () => new Set(songwriterWriterSearchStore.linkedSongwriters.map((writer) => writer.affWriterIpId)),
        [songwriterWriterSearchStore.linkedSongwriters.length]
    )

    return (
        <>
            <title>Catalog Builder</title>
            <div className="songwriter-link-wrapper">
                <ModalPortal isOpen={showFirstTimeSongwriterHubPopup}>
                    <SongwriterHubWelcomePopup
                        onClose={() => {
                            setShowFirstTimeSongwriterHubPopup(false)
                            firstTimeVisit()
                        }}
                    />
                </ModalPortal>
                <ContentHeader title="Catalog Builder" content={<SongwriterCatalogBuilderHeader />} />
                <div className="songwriter-writer-search">
                    <SearchByParty
                        searchPartyStore={songwriterWriterSearchStore}
                        renderPartyResultsTable={(onTitleClick, setLoading) => (
                            <SongwriterCatalogBuilderResults
                                setLoading={setLoading}
                                songwriterWriterSearchStore={songwriterWriterSearchStore}
                            >
                                <SongwriterCatalogBuilderTable
                                    data={songwriterWriterSearchStore.searchResults}
                                    onTitleClick={onTitleClick}
                                    linkedWriterIpIds={linkedWriterIpIdSet}
                                    onWriterToggle={onWriterToggle}
                                />
                            </SongwriterCatalogBuilderResults>
                        )}
                        partyDetailsCardComponent={SearchResultPartyDetailsCard}
                    />
                </div>
            </div>
        </>
    )
}

export default observer(SongwriterCatalogBuilderScene)
